export enum WorkshopStatus {
  WORKSHOP_STATUS_FEE_APPROVAL_PENDING = "FEE_APPROVAL_PENDING",
  /** After fee is paid; awaiting admin/coordinator approval (API may use spaces, e.g. "PENDING APPROVAL"). */
  WORKSHOP_STATUS_PENDING_APPROVAL = "PENDING_APPROVAL",
  WORKSHOP_STATUS_PENDING_CONFIRMATION = "PENDING_CONFIRMATION",
  WORKSHOP_STATUS_CONFIRMED = "CONFIRMED",
  WORKSHOP_STATUS_PROPOSED = "PROPOSED",
  WORKSHOP_STATUS_DONE = "DONE"
}

/**
 * Normalize workshop/site-visit schedule status from API/DB: trim, uppercase,
 * whitespace → underscores (e.g. "Pending Approval" → "PENDING_APPROVAL").
 */
export function normalizeWorkshopScheduleStatus(raw: unknown): string {
  if (raw == null) {
    return "";
  }
  const s = String(raw).trim();
  if (!s) {
    return "";
  }
  return s.replace(/\s+/g, "_").toUpperCase();
}

/** True when a workshop/site-visit schedule already exists (any non-empty status). */
export function hasWorkshopOrSiteVisitSchedule(status: unknown): boolean {
  return normalizeWorkshopScheduleStatus(status) !== "";
}
